<template>
  <Slideover :visible="visible">
    <form v-on:submit.prevent="searchOrders">
      <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
        <div class="flex items-start justify-between space-x-3">
          <h2 class="text-lg leading-7 font-medium">
            {{ title }}
          </h2>
          <div class="h-7 flex items-center">
            <button
              type="button"
              aria-label="Close panel"
              @click="closeSlideover()"
              class="text-green-300 hover:text-white transition ease-in-out duration-150"
            >
              <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <div class="relative flex-1 py-3 px-2 mx-4">
        <div class="mt-6 grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-6">
          <!-- Cart -->
          <div class="sm:col-span-3">
            <label
              for="cart"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Cart
            </label>
            <select
              id="cart"
              v-model="form.CartID"
              class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            >
              <option :value="undefined"></option>
              <option v-for="cart in carts" :key="cart.ID" :value="cart.ID">
                {{ cart.CartName }}
              </option>
            </select>
          </div>

          <!-- Tracking -->
          <div class="sm:col-span-3">
            <label
              for="TrackingID"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Tracking
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="TrackingID"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.TrackingID"
              />
            </div>
          </div>

        </div>
      </div>
      <!-- Footer -->
      <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="button"
            @click="closeSlideover()"
            class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
          >
            Cancel
          </button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <button
            :disabled="searching"
            type="submit"
            class="inline-flex justify-center items-center space-x-2 py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out"
          >
            <span>Search</span>
            <LoadingSpinner v-if="searching" class="text-white" />
          </button>
        </span>
      </div>
    </form>
    <div class="m-2">
      <OrdersGrid height="400" />
    </div>
  </Slideover>
</template>
<script>
import carts from "@/data/carts.json";
import Slideover from "@/components/layout/Slideover.vue";
import OrdersGrid from "@/components/agGrid/OrdersGrid.vue";

export default {
  name: "OrderSearch",
  components: {
    Slideover,
    OrdersGrid
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    footer: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      carts: carts,
      orderClone: {},
      searching: false,
      form: {
        CartID: null,
        TrackingID: null
      }
    };
  },
  computed: {},
  created() {
  },
  methods: {
    searchOrders() {
      this.searching = true;
      // build our nested filters object
      let filter = {
        CartID: this.form.CartID,
        newSearch: true,
        Tracking: {
          TrackingID: this.form.TrackingID
        },
        sort: "-OrderTime"
      };

      this.$store.dispatch("orders/fetchOrders", filter).then(() => {
        this.searching = false;
      });
    },
    closeSlideover() {
      this.$emit('toggle-slideover');
      Object.keys(this.form).forEach(key => this.form[key] = null);
    }
  },
};
</script>
